@if (visible && domains && domains.length > 1) {
  <div class="label">@if (label?.length) {<label>{{ label }}</label>}</div>
  <input type="text" class="domain-search" i18n-placeholder="@@domain.searchPlaceholder" placeholder="Search domains..."
         [(ngModel)]="searchText"
         (ngModelChange)="onSearchChange()">
  <pub-domain-item [selectedIds]="selectedIds" [domain]="allDomain" [showCheckbox]="true"
                   (selected)="onSelect($event)"></pub-domain-item>
  <ul>
    @for (domain of filteredDomains; track domain.id) {
      <li class="path">
        <span class="domain-row">
          <pub-domain-item [selectedIds]="selectedIds" [domain]="domain" [showCheckbox]="true"
                           (selected)="onSelect($event)"></pub-domain-item>
          @if (domain.children?.length) {
            <span class="has-children">&#x25B8;</span>
          }
        </span>
        @if (domain.children?.length && isExpanded(domain)) {
          <ul>
            @for (subdomain of domain.children; track subdomain.id) {
              <li>
                <pub-domain-item [selectedIds]="selectedIds" [domain]="subdomain" [showCheckbox]="true"
                                 (selected)="onSelect($event)"></pub-domain-item>
              </li>
            }
          </ul>
        }
      </li>
    }
  </ul>
}
